'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Constants = require('../../Constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SVGBase = function SVGBase(props) {
  var __isHasMore = props._isHasMore,
      __isListReversed = props._isListReversed,
      __src = props.src,
      __styledJunk0 = props['0'],
      __styledJunk1 = props['1'],
      rest = _objectWithoutProperties(props, ['_isHasMore', '_isListReversed', 'src', '0', '1']);

  return _react2.default.createElement('svg', _extends({ viewBox: '0 0 100 100', xmlns: 'http://www.w3.org/2000/svg' }, rest));
};

SVGBase.propTypes = {
  size: _propTypes2.default.oneOf(Object.keys(_Constants.AVATAR_SIZES)),
  _isHasMore: _propTypes2.default.bool,
  _isListReversed: _propTypes2.default.bool,
  '0': _propTypes2.default.any,
  '1': _propTypes2.default.any,
  src: _propTypes2.default.string
};

exports.default = SVGBase;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.2292/js/UIAvatarDisplay/baseStyledComponents/SVGBase.js
// module id = 502
// module chunks = 177